import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import "../../Auth/Registration/companyDetails.css";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import signUpService from "../../../components/Services/signUp.service";
import documentUploadService from "../../../components/Services/documentUpload.service";
import { toastProperties } from "../../../commons/Toast/Toaster";
import stateCityService from "../../../components/Services/stateCity.service";
import PdfViewerModal from "../../Auth/Registration/pdfViewerModal";
import {
 getCitiesByCorrespondenceState,
 getCitiesByOfficeState,
} from "../../../store/DashBoard/actions";
import {
 getAllStatesbyRegionIdforCon,
 getDiscomByStateIdforCon,
} from "../../../store/Registartion/actions";

const EditCompanyDetails = ({
 tab,
 handleCompanyDetails,
 companyDetails,
 myProfileDetails,
}) => {
 const allCategoryTypes = useSelector(
  (state) => state?.registrationReducer?.allCategoryTypes || []
 );
 const allCreditRatings = useSelector(
  (state) => state?.registrationReducer?.allCreditRatings || []
 );
 const allStateTypes = useSelector(
  (state) => state?.registrationReducer?.allStateTypes || []
 );
 const getNationality = useSelector(
  (state) => state?.registrationReducer?.getNationality || []
 );
 const officeCities = useSelector(
  (state) => state?.dashboardReducer?.officeCities || []
 );
 const correspondenceCities = useSelector(
  (state) => state?.dashboardReducer?.correspondenceCities || []
 );
 const allHoldingCompanyList = useSelector(
  (state) => state?.registrationReducer?.allHoldingCompanyList || []
 );

 const regionTypes = useSelector(
  (state) => state?.registrationReducer?.regionTypes || []
 );
 const discomTypes = useSelector(
  (state) => state?.registrationReducer?.discomTypes || []
 );
 const stateOptionsCon = useSelector(
  (state) => state?.registrationReducer?.stateOptionsCon || []
 );
 const discomOptionsCon = useSelector(
  (state) => state?.registrationReducer?.discomOptionsCon || []
 );

 const initialValues = {
  holdingCompany: myProfileDetails?.companyResponse?.holdingCompanyId,
  userName: myProfileDetails?.userResponse?.userName,
  password: "",
  email: myProfileDetails?.userResponse?.email,
  phone: "",
  name: myProfileDetails?.companyResponse?.name,
  displayName: myProfileDetails?.companyResponse?.displayName,
  description: myProfileDetails?.companyResponse?.description,
  logo: "",
  logoFile: "",
  categoryId: myProfileDetails?.companyResponse?.category?.id,
  registeredAt: myProfileDetails?.companyResponse?.registeredAt
   ? new Date(myProfileDetails?.companyResponse?.registeredAt)
   : "",
  pan: myProfileDetails?.companyResponse?.pan,
  tan: myProfileDetails?.companyResponse?.tan,
  gst: myProfileDetails?.companyResponse?.gst,
  nameAddress: myProfileDetails?.companyResponse?.bankAccounts[0]?.name,
  accNo: myProfileDetails?.companyResponse?.bankAccounts[0]?.accNo,
  ifsc: myProfileDetails?.companyResponse?.bankAccounts[0]?.ifsc,
  address:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.address
    : "",
  cityId:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.cityId
    : "",
  stateAndUtId:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.stateUtId
    : "",
  pin:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.pin
    : "",
  tel:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.tel
    : "",
  officeEmail:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.email
    : "",
  fax:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.fax
    : null,
  contactPersons:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.contactPersons
       .join(",")
       .split(",")
    : "",
  mob:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[0]?.mob
    : "",
  correspondenceAddress:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.address
    : "",
  correspondenceCity:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.cityId
    : "",
  correspondenceState:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.stateUtId
    : "",
  correspondencePinCode:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.pin
    : "",
  correspondenceTelephone:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.tel
    : "",
  correspondenceEmail:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.email
    : "",
  correspondenceFaxNo:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.fax
    : null,
  correspondenceContactPerson:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.contactPersons
       .join(",")
       .split(",")
    : "",
  correspondenceMobileNo:
   myProfileDetails?.companyResponse?.addresses.length > 0
    ? myProfileDetails?.companyResponse?.addresses[1]?.mob
    : "",
  creditRatingId: myProfileDetails?.companyResponse?.creditRating?.id,
  creditRatingYear: myProfileDetails?.companyResponse?.creditRatingYear
   ? new Date(myProfileDetails?.companyResponse?.creditRatingYear)
   : "",
  creditRatingAgency: myProfileDetails?.companyResponse?.creditRatingAgency,
  state1CitiesOptions: [],
  state2CitiesOptions: [],
  //dicom details
  conDiscomId: myProfileDetails?.companyResponse?.plant?.discom?.id,
  conFilteredVoltageLevels: discomTypes?.find(
   (item) => item.id == myProfileDetails?.companyResponse?.plant?.discom?.id
  )?.voltageLevels,
  discomRegionId: myProfileDetails?.companyResponse?.plant?.regionId,
  discomStateUtId: myProfileDetails?.companyResponse?.plant?.stateUtId,
  istsDiscomVoltageId:
   myProfileDetails?.companyResponse?.plant?.company?.istsVoltageLevel,
  stuDiscomVoltageId:
   myProfileDetails?.companyResponse?.plant?.company?.stuVoltageLevel,
 };

 const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
 const tanRegex = /^[A-Z]{4}\d{5}[A-Z]{1}$/;
 const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}$/;

 const validationSchema = Yup.object().shape({
  userName: Yup.string()
   .min(4, "Username Must Be at Least 4 Characters")
   .max(20, "Username must be at most 20 characters"),
  password: Yup.string()
   .min(8, "Password Must Be at Least 8 Characters")
   .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
    "Password size must be 8-20 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character."
   ),
  email: Yup.string()
  .matches(
    /^(?!.*@(?:hotmail|outlook|yahoo|aol|mail|icloud)\.(?:com|uk|fr|in|net|co\.in)$)\w+(?:[\.-]?\w+)*@\w+(?:[\.-]?\w+)*\.\w{2,6}$/,
    "Please enter a valid company email address. Personal email providers are not allowed.")
   .required("Email Required"),
  phone: Yup.string().matches(
   /^[5-9][0-9]{9}$/,
   "Phone Number Must Start with 5 to 9 and Be a Valid 10-Digit Number"
  ),
  pan: Yup.string().matches(panRegex, "Invalid PAN Number"),
  tan: Yup.string().matches(tanRegex, "Invalid TAN Number"),
  gst: Yup.string().matches(gstRegex, "Invalid GST Number"),
  pin: Yup.string().matches(/^\d{6}$/, "Pin Code Must Be a 6-Digit Number"),
  tel: Yup.string().matches(
   /^\d{10}$/,
   "Telephone Number Must Be a 10-Digit Number"
  ),
  officeEmail: Yup.string().email("Invalid Email Address"),
  contactPersons: Yup.array()
   .of(Yup.string())
   .min(1, "At least one Contact Person's Name is Required"),
  mob: Yup.string().matches(
   /^[5-9][0-9]{9}$/,
   "Phone Number Must Start with 5 to 9 and Be a Valid 10-Digit Number"
  ),
  correspondencePinCode: Yup.string().matches(
   /^\d{6}$/,
   "Pin code Must Be a 6-Digit Number"
  ),
  correspondenceTelephone: Yup.string().matches(
   /^\d{10}$/,
   "Telephone Number Must Be a 10-Digit Number"
  ),
  correspondenceEmail: Yup.string().email("Invalid Email Address"),
  correspondenceContactPerson: Yup.array()
   .of(Yup.string())
   .min(1, "At Least One Contact Person's Name is Required"),
  correspondenceMobileNo: Yup.string().matches(
   /^[5-9][0-9]{9}$/,
   "Phone Number Must Start with 5 to 9 and Be a Valid 10-Digit Number"
  ),
 });
 const [selectedState, setSelectedState] = useState("");
 const [cityData, setCityData] = useState([]);
 const [selectedCorrespondenceState, setSelectedCorrespondenceState] =
  useState("");
 const [CorresCityData, setCorresCityData] = useState([]);
 const [pdfUrl, setPdfUrl] = useState("");
 const [isOpen, setIsOpen] = useState(false);

 const dispatch = useDispatch();

 const handleBusinessRulesUrl = () => {
  setPdfUrl("");
  documentUploadService.getBusinessRulesUrl().then((response) => {
   if (response?.data?.code === 200) {
    setIsOpen(true);
    setPdfUrl(response?.data?.data?.url);
   }
  });
 };

 const handleByeLawsUrl = () => {
  setPdfUrl("");
  documentUploadService.getByeLawsUrl().then((response) => {
   if (response?.data?.code === 200) {
    setIsOpen(true);
    setPdfUrl(response?.data?.data?.url);
   }
  });
 };

 const handleCloseModal = () => {
  setIsOpen(false);
 };

 const handleStateChange = (fieldName, e, setFieldValue) => {
  const selectedValue = e.target.value;
  // setSelectedState(selectedValue);
  // setFieldValue('stateAndUtId', selectedValue);
  if (fieldName === "stateAndUtId") {
   setSelectedState(selectedValue);
   setFieldValue("stateAndUtId", selectedValue);
  } else if (fieldName === "correspondenceState") {
   setSelectedCorrespondenceState(selectedValue);
   setFieldValue("correspondenceState", selectedValue);
  }
 };

 useEffect(() => {
  if (selectedState) {
   stateCityService
    .getCityByState(selectedState)
    .then((response) => {
     setCityData(response?.data?.data);
    })
    .catch((error) => {
     console.error("API call error:", error);
    });
  }
 }, [selectedState]);

 useEffect(() => {
  if (selectedCorrespondenceState) {
   stateCityService
    .getCityByState(selectedCorrespondenceState)
    .then((response) => {
     setCorresCityData(response?.data?.data);
    })
    .catch((error) => {
     console.error("API call error", error);
    });
  }
 }, [selectedCorrespondenceState]);

 useEffect(() => {
  if (selectedState) {
   getCitiesByOfficeState(selectedState, dispatch);
  }
 }, [selectedState]);

 useEffect(() => {
  if (selectedCorrespondenceState) {
   getCitiesByCorrespondenceState(selectedCorrespondenceState, dispatch);
  }
 }, [selectedCorrespondenceState]);

 const numberInputOnWheelPreventChange = (e) => {
  // Prevent the input value change
  e.target.blur();
  // Prevent the page/container scrolling
  e.stopPropagation();
  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
   e.target.focus();
  }, 0);
 };
 useEffect(() => {
  getCitiesByCorrespondenceState(
   myProfileDetails?.companyResponse?.addresses[1]?.stateUtId,
   dispatch
  );
  getCitiesByOfficeState(
   myProfileDetails?.companyResponse?.addresses[0]?.stateUtId,
   dispatch
  );
  if (initialValues?.discomRegionId && initialValues?.discomStateUtId) {
   getAllStatesbyRegionIdforCon(initialValues?.discomRegionId, dispatch);
   getDiscomByStateIdforCon(initialValues?.discomStateUtId, dispatch);
  }
 }, []);

 return (
  <>
   {isOpen && (
    <PdfViewerModal
     isOpen={isOpen}
     handleCloseModal={handleCloseModal}
     pdfUrl={pdfUrl}
    ></PdfViewerModal>
   )}
   <Formik
    initialValues={companyDetails || initialValues}
    enableReinitialize
    validationSchema={validationSchema}
    onSubmit={(values) => {
     handleCompanyDetails(values);
    }}
   >
    {({
     values,
     errors,
     setFieldValue,
     setFieldTouched,
     setFieldError,
     setValues,
    }) => {
     const handleCheckUserName = (uName) => {
      signUpService.getUsernameExists(uName).then((response) => {
       if (response?.data?.code === 200) {
        toast.error(response?.data?.error, toastProperties);
        setFieldError("userName", response?.data?.error);
       }
      });
     };
     console.log("editCompanyDetails_form_values===>", { values, errors });
     return (
      <Form>
       <Row className="mb-3">
        <Col md={6}>
         <label htmlFor="holdingCompany">Holding company*</label>
         <Field
          as="select"
          name="holdingCompany"
          onChange={(e) => setFieldValue("holdingCompany", e.target.value)}
          className={`custom-input ${
           values.holdingCompany ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select Holding Company</option>
          {allHoldingCompanyList.map((item) => (
           <option key={item.id} value={item.id}>
            {item.name}
           </option>
          ))}
         </Field>
         <ErrorMessage
          name="holdingCompany"
          className="text-danger"
          component="div"
         />
        </Col>
       </Row>
       <Row className="mb-3"></Row>
       <hr />
       <h6>Company Details</h6>
       <Row>
        <Col>
         <div className="mb-3">
          <label htmlFor="name">Company Name</label>
          <Field
           type="text"
           name="name"
           className="form-control custom-input"
          />
          <ErrorMessage name="name" className="text-danger" component="div" />
         </div>
        </Col>
       </Row>
       <Row>
        <Col md={12}>
         <div className="mb-3">
          <label htmlFor="displayName">Company Display Name</label>
          <Field
           type="text"
           name="displayName"
           className="form-control custom-input"
          />
          <ErrorMessage
           name="displayName"
           className="text-danger"
           component="div"
          />
         </div>
         <div className="mb-3">
          <label htmlFor="description">Company Description</label>
          <Field
           type="text"
           name="description"
           className="form-control custom-input"
          />
         </div>
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={6}>
         <label htmlFor="categoryId">Category</label>
         <Field
          as="select"
          name="categoryId"
          onChange={(e) => setFieldValue("categoryId", e.target.value)}
          className={`custom-input ${
           values.categoryId ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select Category*</option>
          {allCategoryTypes.map((item) => (
           <option key={item.id} value={item.id}>
            {item.name}
           </option>
          ))}
         </Field>
         <ErrorMessage
          name="categoryId"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={6}>
         <label htmlFor="registeredAt">
          Date of Incorporation/Registration
         </label>
         <DatePicker
          className="form-control custom-input w-100"
          name="registeredAt"
          selected={values.registeredAt}
          onChange={(e) => setFieldValue("registeredAt", e)}
          dateFormat="dd-MMM-yyyy"
          onBlur={() => setFieldTouched("registeredAt", true)}
          autoComplete="off"
          showYearDropdown
          showMonthDropdown
          scrollableMonthYearDropdown
         />
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={4}>
         <label htmlFor="pan">Pan Number</label>
         <Field type="text" name="pan" 
          onChange={(e) => setFieldValue("pan", e.target.value.toUpperCase())}
         className="form-control custom-input" />
         <ErrorMessage name="pan" className="text-danger" component="div" />
        </Col>
        <Col md={4}>
         <label htmlFor="tan">TAN Number</label>
         <Field type="text" name="tan" onChange={(e) => setFieldValue("tan", e.target.value.toUpperCase())} className="form-control custom-input" />
         <ErrorMessage name="tan" className="text-danger" component="div" />
        </Col>
        <Col>
         <label htmlFor="gst">GST Number</label>
         <Field type="text" name="gst" onChange={(e) => setFieldValue("gst", e.target.value.toUpperCase())} className="form-control custom-input" />
         <ErrorMessage name="gst" className="text-danger" component="div" />
        </Col>
       </Row>
       <hr
        style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
       ></hr>
       <h6>Bank Details - Current Account</h6>
       <Row>
        <Col>
         <div className="mb-3">
          <label htmlFor="nameAddress">Name and Branch Address</label>
          <Field
           type="text"
           name="nameAddress"
           className="form-control custom-input"
          />
         </div>
        </Col>
       </Row>
       <Row>
        <Col>
         <div className="mb-3">
          <label htmlFor="accNo">Account No</label>
          <Field
           type="text"
           name="accNo"
           className="form-control custom-input"
          />
          <ErrorMessage name="accNo" className="text-danger" component="div" />
         </div>
        </Col>
       </Row>
       <Row className="mb-3">
        <Col>
         <label htmlFor="ifsc">IFSC Code</label>
         <Field type="text" name="ifsc" className="form-control custom-input" />
         <ErrorMessage name="ifsc" className="text-danger" component="div" />
        </Col>
        <Col></Col>
       </Row>
       <hr
        style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
       ></hr>
       <h6>Office Address</h6>
       <Row>
        <Col>
         <div className="mb-3">
          <label htmlFor="address">Registered Office Address</label>
          <Field
           type="text"
           name="address"
           className="form-control custom-input"
          />
          <ErrorMessage
           name="address"
           className="text-danger"
           component="div"
          />
         </div>
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={4}>
         <label htmlFor="stateAndUtId">State</label>
         <Field
          as="select"
          name="stateAndUtId"
          onChange={(e) => handleStateChange("stateAndUtId", e, setFieldValue)}
          className={`custom-input ${
           values.stateAndUtId ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select State</option>
          {allStateTypes.map((item) => (
           <option key={item.id} value={item.id}>
            {item.name} ({item.label})
           </option>
          ))}
         </Field>
         <ErrorMessage
          name="stateAndUtId"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={4}>
         <label htmlFor="cityId">City</label>
         <Field
          as="select"
          name="cityId"
          onChange={(e) => setFieldValue("cityId", e.target.value)}
          className={`custom-input ${
           values.cityId ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select City</option>
          {officeCities.map((item) => (
           <option key={item.id} value={item.id}>
            {item.name}
           </option>
          ))}
         </Field>
         <ErrorMessage name="cityId" className="text-danger" component="div" />
        </Col>
        <Col md={4}>
         <label htmlFor="pin">Pin Code</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="pin"
          className="form-control custom-input"
         />
         <ErrorMessage name="pin" className="text-danger" component="div" />
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={4}>
         <label htmlFor="tel">Telephone</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="tel"
          className="form-control custom-input"
         />
         <ErrorMessage name="tel" className="text-danger" component="div" />
        </Col>
        <Col md={4}>
         <label htmlFor="officeEmail">Email</label>
         <Field
          type="text"
          name="officeEmail"
          className="form-control custom-input"
         />
         <ErrorMessage
          name="officeEmail"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={4}>
         <label htmlFor="fax">Fax No.(With STD Code)</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="fax"
          className="form-control custom-input"
         />
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={6}>
         <label htmlFor="contactPersons">Name of the Contact Person(s)</label>
         <Field
          type="text"
          name="contactPersons"
          onChange={(e) =>
           setFieldValue("contactPersons", (e.target.value || "").split(","))
          }
          className="form-control custom-input"
         />
         <ErrorMessage
          name="contactPersons"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={6}>
         <label htmlFor="mob">Mobile No</label>
         <Field
          name="mob"
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          className="form-control custom-input"
         />
         <ErrorMessage name="mob" className="text-danger" component="div" />
        </Col>
       </Row>
       <hr
        style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
       ></hr>
       <h6>Correspondence Address</h6>
       <Row>
        <Col>
         <div className="mb-3">
          <label htmlFor="correspondenceAddress">
           Address For Correspondence
          </label>
          <Field
           type="text"
           name="correspondenceAddress"
           className="form-control custom-input"
          />
          <ErrorMessage
           name="correspondenceAddress"
           className="text-danger"
           component="div"
          />
         </div>
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={4}>
         <label htmlFor="correspondenceState">State</label>
         <Field
          as="select"
          name="correspondenceState"
          onChange={(e) =>
           handleStateChange("correspondenceState", e, setFieldValue)
          }
          className={`custom-input ${
           values.correspondenceState ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select State*</option>
          {allStateTypes.map((item) => (
           <option key={item.id} value={item.id}>
            {item.name} ({item.label})
           </option>
          ))}
         </Field>
         <ErrorMessage
          name="correspondenceState"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={4}>
         <label htmlFor="correspondenceCity">City</label>
         <Field
          as="select"
          name="correspondenceCity"
          onChange={(e) => setFieldValue("correspondenceCity", e.target.value)}
          className={`custom-input ${
           values.correspondenceCity ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select City*</option>
          {correspondenceCities.map((item) => (
           <option key={item.id} value={item.id}>
            {item.name}
           </option>
          ))}
         </Field>
         <ErrorMessage
          name="correspondenceCity"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={4}>
         <label htmlFor="correspondencePinCode">Pin Code</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="correspondencePinCode"
          className="form-control custom-input"
         />
         <ErrorMessage
          name="correspondencePinCode"
          className="text-danger"
          component="div"
         />
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={4}>
         <label htmlFor="correspondenceTelephone">Telephone</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="correspondenceTelephone"
          className="form-control custom-input"
         />
         <ErrorMessage
          name="correspondenceTelephone"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={4}>
         <label htmlFor="correspondenceEmail">Email</label>
         <Field
          type="text"
          name="correspondenceEmail"
          className="form-control custom-input"
         />
         <ErrorMessage
          name="correspondenceEmail"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={4}>
         <label htmlFor="correspondenceFaxNo">Fax No.(With STD Code)</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="correspondenceFaxNo"
          className="form-control custom-input"
         />
        </Col>
       </Row>
       <Row className="mb-3">
        <Col md={6}>
         <label htmlFor="correspondenceContactPerson">
          Name of the Contact Person(s)
         </label>
         <Field
          type="text"
          name="correspondenceContactPerson"
          onChange={(e) =>
           setFieldValue(
            "correspondenceContactPerson",
            (e.target.value || "").split(",")
           )
          }
          className="form-control custom-input"
         />
         <ErrorMessage
          name="correspondenceContactPerson"
          className="text-danger"
          component="div"
         />
        </Col>
        <Col md={6}>
         <label htmlFor="correspondenceMobileNo">Mobile No</label>
         <Field
          type="number"
          onWheel={numberInputOnWheelPreventChange}
          name="correspondenceMobileNo"
          className="form-control custom-input"
         />
         <ErrorMessage
          name="correspondenceMobileNo"
          className="text-danger"
          component="div"
         />
        </Col>
       </Row>
       <hr
        style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
       ></hr>
       {tab == 4 && (
        <>
         <Row className="mb-3">
          <h6>Banking Details</h6>
          <div className="col-md-6">
           <label htmlFor="discomRegionId">Region*</label>
           <Field
            as="select"
            className={`custom-input ${
             values.discomRegionId ? "" : "custom-input-color"
            } w-100`}
            name={"discomRegionId"}
            onChange={(e) => {
             setFieldValue("discomRegionId", e.target.value);
             getAllStatesbyRegionIdforCon(e.target.value, dispatch);
            }}
           >
            <option value="">Select Region*</option>
            {regionTypes.map((item) => (
             <option key={item?.id} value={item?.id}>
              {item?.name}
             </option>
            ))}
           </Field>
           <ErrorMessage
            name="discomRegionId"
            className="text-danger"
            component="div"
           />
          </div>
          <div className="col-md-6">
           <label htmlFor="discomStateUtId">State*</label>
           <Field
            as="select"
            className={`custom-input ${
             values.discomStateUtId ? "" : "custom-input-color"
            } w-100`}
            name={"discomStateUtId"}
            onChange={(e) => {
             setFieldValue("discomStateUtId", e.target.value);
             getDiscomByStateIdforCon(e.target.value, dispatch);
            }}
           >
            <option value="">Select State*</option>
            {stateOptionsCon.map((item) => (
             <option key={item?.id} value={item?.id}>
              {item?.name}
             </option>
            ))}
           </Field>
           <ErrorMessage
            name="discomStateUtId"
            className="text-danger"
            component="div"
           />
          </div>
         </Row>
         <Row className="justify-content-center align-items-center mb-4">
          <div className="col-md-6">
           <label htmlFor="conDiscomId">Name of Banking*</label>
           <Field
            as="select"
            name={"conDiscomId"}
            className={`custom-input ${
             values.conDiscomId ? "" : "custom-input-color"
            } w-100`}
            onChange={(e) => {
             setValues({
              ...values,
              conFilteredVoltageLevels: discomTypes?.find(
               (item) => item.id == e.target.value
              )?.voltageLevels,
              conDiscomId: e.target.value,
              istsDiscomVoltageId: "",
              stuDiscomVoltageId: "",
             });
            }}
           >
            <option value="">Select Name of Banking</option>
            {discomOptionsCon?.map((item) => (
             <option key={item?.id} value={item?.id}>
              {item?.acronym}
             </option>
            ))}
           </Field>
           <ErrorMessage
            name="conDiscomId"
            className="text-danger"
            component="div"
           />
          </div>
          <div className="col-md-6">
           <label htmlFor="istsDiscomVoltageId">ISTS Voltage level*</label>
           <Field
            as="select"
            className={`custom-input ${
             values.istsDiscomVoltageId ? "" : "custom-input-color"
            } w-100`}
            name="istsDiscomVoltageId"
            onChange={(e) =>
             setFieldValue("istsDiscomVoltageId", e.target.value)
            }
           >
            <option value="">Select Voltage level</option>
            {(values.conFilteredVoltageLevels || [])?.map(
             (voltageItem, index) => (
              <option key={index} value={voltageItem}>
               {voltageItem}
              </option>
             )
            )}
           </Field>
           <ErrorMessage
            name="istsDiscomVoltageId"
            className="text-danger"
            component="div"
           />
          </div>
         </Row>
         <Row>
          <div className="col-md-6">
           <label htmlFor="stuDiscomVoltageId">STU Voltage level*</label>
           <Field
            as="select"
            className={`custom-input ${
             values.stuDiscomVoltageId ? "" : "custom-input-color"
            } w-100`}
            name="stuDiscomVoltageId"
            onChange={(e) =>
             setFieldValue("stuDiscomVoltageId", e.target.value)
            }
           >
            <option value="">Select Voltage level</option>
            {(values.conFilteredVoltageLevels || [])?.map(
             (voltageItem, index) => (
              <option key={index} value={voltageItem}>
               {voltageItem}
              </option>
             )
            )}
           </Field>
           <ErrorMessage
            name="stuDiscomVoltageId"
            className="text-danger"
            component="div"
           />
          </div>
         </Row>
         <hr
          style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
         ></hr>
        </>
       )}
       <Row className="mb-3">
        <Col md={4}>
         <label htmlFor="creditRatingId">Credit Rating</label>
         <Field
          as="select"
          name="creditRatingId"
          onChange={(e) => setFieldValue("creditRatingId", e.target.value)}
          className={`custom-input ${
           values.creditRatingId ? "" : "custom-input-color"
          } w-100`}
         >
          <option value="">Select Credit Rating</option>
          {allCreditRatings.map((item) => (
           <option key={item.id} value={item.id}>
            {item.rating}
           </option>
          ))}
         </Field>
        </Col>
        <Col md={4}>
         <label htmlFor="creditRatingYear">Credit Rating Year</label>
         <DatePicker
          className="form-control custom-input w-100"
          name="creditRatingYear"
          selected={values.creditRatingYear}
          onChange={(e) => setFieldValue("creditRatingYear", e)}
          dateFormat="MMM-yyyy"
          onBlur={() => setFieldTouched("creditRatingYear", true)}
          autoComplete="off"
          showMonthYearPicker
         />
        </Col>
        <Col md={4}>
         <label htmlFor="creditRatingAgency">Credit Rating Agency</label>
         <Field
          type="text"
          name="creditRatingAgency"
          className="form-control custom-input"
         />
        </Col>
       </Row>
       <hr
        style={{ width: "100%", margin: "20px auto", marginBottom: "20px" }}
       ></hr>
       <Row className="mb-3">
        <div className="text-center mt-4 fw-bold">
         <Button className="btn btn-lg btn-signup py-3 px-4" type="submit">
          Save & Proceed <i className="fa fa-chevron-right fs-6"></i>
         </Button>
        </div>
       </Row>
      </Form>
     );
    }}
   </Formik>
  </>
 );
};

export default EditCompanyDetails;
